import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import type { StatisticsCardItem } from '@/views/dashboard/_components/statistics-cards/types'
import type { AccessRestrictionStatCardKey } from './access-restriction-statistics-cards.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    todayBlockedDomains: { default: 0 },
    effectivePolicies: { default: 0 }
  },
  emits: ["statClick"],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n()
const props = __props

const emit = __emit

const statisticsItems = computed((): StatisticsCardItem[] => {
  void locale.value
  const today = props.todayBlockedDomains ?? 0
  return [
    {
      label: t('accessRestriction.todayBlockedDomains'),
      value: today,
      span: 12,
      clickable: today > 0,
      events: {
        click: () => {
          if (today <= 0) return
          emit('statClick', 'todayBlockedDomains')
        }
      }
    },
    { label: t('accessRestriction.effectivePolicies'), value: props.effectivePolicies, span: 12, clickable: false }
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]))
}
}

})